const $ = require('jquery')
const View = require('public_framework/view')
const Autocomplete = require('yet-another-autocomplete').default
const googleMapsLoader = require('shared/javascripts/public_framework/services/google_maps_loader')

/**
 * An autocomplete for Google Places API.
 * @see https://developers.google.com/maps/documentation/javascript/reference#AutocompleteService
 *
 * Expects `data-value-type` provided on the input component, based on which
 * it will set value as an place ID or as a simple test.
 * @see app/inputs/location_autocomplete_input.rb
*/

const CITIES_SKOPE = ['(cities)']
const REGIONS_SCOPE = ['(regions)']

module.exports = class LocationAutocompleteView extends View {
  constructor () {
    super(...arguments)
    googleMapsLoader.onReady(this.init.bind(this))
  }

  init () {
    this.service = new window.google.maps.places.AutocompleteService()
    this.input = this.el.querySelector('input[type="text"]')
    this.hiddenField = this.el.querySelector('input[type="hidden"]')
    this.spinner = this.el.querySelector('[data-role="spinner"]')
    this.communityRedesignEnabled = false
    this.regions = this.input.dataset.regions || false

    this.autocomplete = new Autocomplete(this.input, {
      query: this.onQuery.bind(this),
      onSelect: this.onSelect.bind(this)
    })

    this.autocomplete.container.classList.add('autocomplete_v2')
    this.autocomplete.container.classList.remove('autocomplete_box')

    this.input.addEventListener('blur', () => {
      this.input.classList.remove('no-bottom-left-radius')
    })

    this.input.addEventListener('keyup', () => {
      if (this.input.value === '') {
        this.input.classList.remove('no-bottom-left-radius')
      }
    })
  }

  onQuery (term, setSuggestions) {
    if (!term) {
      setSuggestions([])
      if (this.communityRedesignEnabled) {
        this.input.classList.remove('no-bottom-left-radius')
      }
      return
    }
    this.spinner.style.display = 'block'
    this.service.getPlacePredictions({input: term, types: this.regions ? REGIONS_SCOPE : CITIES_SKOPE}, results => {
      this.spinner.style.display = 'none'

      if (!results) {
        setSuggestions([])
        this.input.classList.remove('no-bottom-left-radius')
        return
      }

      const suggestions = results.map(r => ({
        text: r.description,
        value: r.place_id
      }))

      if (this.communityRedesignEnabled) {
        if (suggestions.length !== 0) {
          this.input.classList.add('no-bottom-left-radius')
        } else {
          this.input.classList.remove('no-bottom-left-radius')
        }
      }

      setSuggestions(suggestions)
    })
  }

  onSelect (option) {
    this.input.value = option.text
    const value = this.input.dataset.valueType === 'text' ? option.text : option.value

    $(this.input).trigger('location_selected', {value})
    this.hiddenField.value = value
    this.input.classList.remove('no-bottom-left-radius')
  }

  onUnload () {
    this.autocomplete.destroy()
    this.input.classList.remove('no-bottom-left-radius')
  }
}



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/ui/autocomplete/views/location_autocomplete.js